export class DownloadsPageQuery {
  category?: string;
  type?: string;
  brands?: string[];
  page?: number;
}
